import {
  buildHtml,
  CBoxContentGroup,
  ContentRoute,
  createMapper,
  RouteSlotInput,
} from '@caritas/ui';

import { isDefined } from '../../utils/is-defined';
import { mapHtmlBlock } from './HtmlBlock.mappers';

const mapCBoxContent = createMapper<
  Array<CBoxContentFragment>,
  RouteSlotInput<typeof CBoxContentGroup, 'items'>
>({
  BlockHtmlParagraph: mapHtmlBlock,
  BlockHtmlList: mapHtmlBlock,
});

export function mapCBox(
  input: BlockCBoxFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'CBox'> {
  return {
    key: 'CBox',
    input: () => [
      {
        heading: input.heading,
        Subheading: input.subheading ? buildHtml(input.subheading) : undefined,
        content: {
          items: mapCBoxContent(input.content?.filter(isDefined) || []),
        },
      },
      200,
    ],
  };
}
